
export function callUrlStream(url: string, sendData: string,
                              callback: (res: string) => void, callbackDone: (data: string, suc: boolean) => void) {
    let last_response_len = 0;
    const xhrFields: any = {
        onprogress: (e: any) => {
            const response = e.currentTarget.response;
            let this_response;
            if (last_response_len === 0) {
                this_response = response;
                last_response_len = response.length;
            } else {
                this_response = response.substring(last_response_len);
                last_response_len = response.length;
            }
            // console.log('R:' + this_response);
            callback(this_response);
        }
    };
    $.ajax(url, {
        xhrFields
    })
    .done(function(data) {
        callbackDone(data, true);
    })
    .fail(function(data) {
        callbackDone(undefined, false);
    });
  }
